var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    y: 0.702,
    fill: "#99A2AD",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M30 20.702c0 5.522-4.477 10-10 10s-10-4.478-10-10 4.477-10 10-10 10 4.477 10 10m-9.042-3.069c-1.718.742-6.671 2.85-6.671 2.85-1.174.475-.487.92-.487.92s1.002.356 1.861.623c.86.267 1.317-.03 1.317-.03s2.005-1.365 4.037-2.82c1.432-1.008 1.089-.177.745.179-.745.771-1.976 1.988-3.007 2.968-.458.415-.229.772-.028.95.583.511 1.956 1.44 2.58 1.863.172.117.287.195.312.214.143.12.945.653 1.431.535.487-.119.545-.802.545-.802s.372-2.434.715-4.66l.187-1.264c.154-1.037.28-1.879.3-2.179.086-1.009-.945-.593-.945-.593s-2.233.95-2.892 1.246",
    clipRule: "evenodd"
  })));
};
export default SvgTelegram;